import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';


function CtaBanner({ widget }) {
  if (!widget) {
    return null;
  }

  return (
    <div className="cta-buttons">
      <div className="container">
        <div className="row">
          {
            widget.cta_items.map(item => (
              <div className="col" key={item.title}>
                <div className="cta-button-wrapper">
                  <Link name={item.route}>
                    <div className="cta-button-inner" style={{ backgroundImage: `url(${buildThumbnailUrl(item.image.contentUrl, { width: 500, height: 500 })})` }}>
                      <div className="box">
                        <img src="/images/icon-right-arrow-white.svg" alt="Right Arrow" />
                      </div>
                      <div className="overlay">
                        {item.title}
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}


CtaBanner.propTypes = {
  widget: PropTypes.object,
};

CtaBanner.defaultProps = {
  widget: undefined,
};

export default withData({
  widget: 'cta_banner',
})(CtaBanner);



// WEBPACK FOOTER //
// ./src/components/CtaBanner/index.js